/** Trilha de auditoria — tipos e chamadas, separados do `endpoints.ts`. */

import { api } from './client';

export type TipoEvento = 'criacao' | 'atualizacao' | 'exclusao' | 'acesso';
export type TipoAcao = TipoEvento | 'misto';

export interface CampoAlterado {
  campo: string;
  rotulo: string;
  antes: string | null;
  depois: string | null;
}

export interface EventoAuditado {
  id: number;
  quando: string;
  usuario_nome: string | null;
  acao: string;
  tipo: TipoEvento;
  entidade: string | null;
  entidade_rotulo: string;
  entidade_id: string | null;
  registro_rotulo: string | null;
  descricao: string | null;
  campos: CampoAlterado[];
}

export interface ResumoEntidade {
  entidade: string;
  rotulo: string;
  criados: number;
  alterados: number;
  excluidos: number;
}

export interface AcaoAuditada {
  chave: string;
  quando: string;
  usuario_id: number | null;
  usuario_nome: string | null;
  origem: 'aplicacao' | 'sistema';
  usuario_banco: string | null;
  rota: string | null;
  ip: string | null;
  navegador: string | null;
  titulo: string;
  tipo: TipoAcao;
  total_registros: number;
  entidades: ResumoEntidade[];
  eventos: EventoAuditado[];
  parcial: boolean;
}

export interface PaginaDeAcoes {
  itens: AcaoAuditada[];
  total: number;
  pagina: number;
  tamanho: number;
}

export interface OpcaoFiltro {
  valor: string;
  rotulo: string;
}

export interface FiltroAuditoria {
  inicio?: string;
  fim?: string;
  usuario_id?: string;
  entidade?: string;
  tipo?: TipoEvento;
  origem?: 'aplicacao' | 'sistema';
  busca?: string;
}

/** Tira os vazios: query string com `usuario_id=` vira 422 no servidor. */
function limpar(filtro: FiltroAuditoria): Record<string, string> {
  return Object.fromEntries(
    Object.entries(filtro).filter(([, v]) => v !== undefined && v !== ''),
  ) as Record<string, string>;
}

export const ApiAuditoria = {
  acoes: async (filtro: FiltroAuditoria, pagina: number): Promise<PaginaDeAcoes> =>
    (
      await api.get<PaginaDeAcoes>('/auditoria/acoes', {
        params: { ...limpar(filtro), pagina, tamanho: 30 },
      })
    ).data,
  acao: async (chave: string): Promise<AcaoAuditada> =>
    (await api.get<AcaoAuditada>(`/auditoria/acoes/${encodeURIComponent(chave)}`)).data,
  historico: async (entidade: string, id: string): Promise<EventoAuditado[]> =>
    (
      await api.get<EventoAuditado[]>(
        `/auditoria/registro/${encodeURIComponent(entidade)}/${encodeURIComponent(id)}`,
      )
    ).data,
  filtros: async (): Promise<{ usuarios: OpcaoFiltro[]; entidades: OpcaoFiltro[] }> =>
    (await api.get('/auditoria/filtros')).data,
};
